import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import intersect from "./directives/intersect";

const app = createApp(App);

//---------- Local ----------//
// app.provide("url", "http://127.0.0.1:5000/ms_piplatam/");

//---------- Pruebas ----------//
// app.provide("url", "https://devs.piplatam.com/ms_piplatam/");
// app.provide("urlStatics", "https://devs.piplatam.com/");
// app.provide("urlSite", "https://demo.piplatam.com/");

//---------- Producción ----------//
app.provide("url", "https://www.piplatam.com/ms_piplatam/");
app.provide("urlStatics", "https://www.piplatam.com/");
app.provide("urlSite", "https://priv.piplatam.com/");

app.use(router);
app.directive("intersect", intersect);
app.mount("#app");
